export var NavigationType;
(function (NavigationType) {
    NavigationType["PRIMARY"] = "primary";
    NavigationType["SECONDARY"] = "secondary";
})(NavigationType || (NavigationType = {}));
